export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de procesos"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ratios"])},
          "new_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nuevo ratio"])},
          "edit_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])},
          "destroy_button_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "destroy_button_title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Eliminar ratio del día ", _interpolate(_named("day"))])},
          "destroy_button_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Está seguro de eliminar el ratio?"])},
          "destroy_button_label_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to process list"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ratios"])},
          "new_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New ratio"])}
        }
      }
    }
  })
}